/** The strings for this feature, in the active language — see src/lib/i18n.js. */
import { pickLocale } from '../../lib/i18n'
import * as ar from './strings.ar'
import * as en from './strings.en'

export const companiesStrings = pickLocale(ar.companiesStrings, en.companiesStrings)
export const licenseManagementStrings = pickLocale(ar.licenseManagementStrings, en.licenseManagementStrings)
export const companyProfileStrings = pickLocale(ar.companyProfileStrings, en.companyProfileStrings)
export const licenseInformationStrings = pickLocale(ar.licenseInformationStrings, en.licenseInformationStrings)
